<template>
  <div class="slider-home cat-carousel" v-show="cursos && cursos.length > 0">
    <div class="d-flex align-items-center justify-content-between w-100">
      <h2 class="float-left">Cursos</h2>
      <div class="ver-todas-categorias">
        <a @click="$router.push('cursos/categoria/1')">VER TODOS</a>
      </div>
    </div>
    <carousel :dots="false" ref="carouselCursosHome">
      <carousel-item v-for="(curso, index) in cursos"
                    :key="curso.curso_id + '-' + index"
                    :titulo="curso.nome"
                    :imagem="curso.imagem_capa"
                    texto-url="ver curso"
                    :url="`/cursos/detalhe/${curso.referencia}`" />
    </carousel>
  </div>
</template>

<script>
import CarouselItem from '@/core/components/CarouselItem'
import Carousel from '@/core/components/Carousel'

export default {
  name: 'CursosHomeCarousel',
  components: { Carousel, CarouselItem },
  props: {
    cursos: Array
  },
  methods: {
    applyOwlCarousel: function () {
      this.$refs.carouselCursosHome.applyOwlCarousel()
    }
  }
}
</script>

<style scoped>
</style>
